export default {"src":"/_next/static/media/3.7829139b.svg","height":80,"width":98,"blurWidth":0,"blurHeight":0};